export default {
  ADD_PAYMENT_METHOD: (state, newPaymentMethod) => {
    state.paymentMethods.push(newPaymentMethod)
  },
  RESET_PAYMENT_METHODS: (state) => {
    state.paymentMethods = []
  },
  SET_PAYMENT_METHODS: (state, paymentMethods) => {
    state.paymentMethods = paymentMethods
  },
}
